"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UserMenu = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("../../../../hooks");
var _UserInfo = require("../UserInfo/UserInfo");
var _Icon = require("../../../UIElements/Icons/PetSure/Icon");
var _pageStatePropTypes = require("../../../../propTypes/pageStatePropTypes");
require("./userMenu.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UserMenu = _ref => {
  let {
    user,
    condensed = false,
    onLogout = () => {},
    customTrackingData,
    customTrackingEvents
  } = _ref;
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const menuTrigger = (0, _react.useRef)(null);
  const settingsLink = (0, _react.useRef)(null);
  const logoutLink = (0, _react.useRef)(null);
  const userMenuPopover = (0, _react.useRef)(null);
  const userMenuWrapper = (0, _react.useRef)(null);
  (0, _hooks.useOnClickOutside)(userMenuWrapper, () => setIsOpen(false));
  (0, _hooks.useTracking)({
    elementRef: menuTrigger,
    trackingProps: {
      label: 'User menu trigger',
      elementType: 'button'
    },
    customTrackingData,
    customTrackingEvents
  });
  (0, _hooks.useTracking)({
    elementRef: settingsLink,
    trackingProps: {
      label: 'User menu settings link',
      elementType: 'button'
    },
    customTrackingData,
    customTrackingEvents
  });
  (0, _hooks.useTracking)({
    elementRef: logoutLink,
    trackingProps: {
      label: 'User menu logout link',
      elementType: 'button'
    },
    customTrackingData,
    customTrackingEvents
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: userMenuWrapper,
    className: "userMenu ".concat(isOpen ? 'open' : 'closed')
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-haspopup": "true",
    "aria-controls": "userMenuPopover",
    "aria-expanded": isOpen,
    className: "userInfoLink",
    id: "userMenu_trigger",
    type: "button",
    onClick: () => setIsOpen(!isOpen),
    ref: menuTrigger
  }, /*#__PURE__*/_react.default.createElement(_UserInfo.UserInfo, {
    user: user,
    condensed: condensed
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "caret_down"
  })), isOpen && /*#__PURE__*/_react.default.createElement("div", {
    ref: userMenuPopover,
    id: "userMenuPopover",
    className: "userMenuPopover",
    "aria-labelledby": "userMenu_trigger",
    role: "menu"
  }, /*#__PURE__*/_react.default.createElement("a", {
    role: "menuitem",
    href: "/settings",
    ref: settingsLink
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "settings"
  }), "Settings"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    role: "menuitem",
    onClick: () => onLogout(),
    ref: logoutLink
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "lock"
  }), "Logout")));
};
exports.UserMenu = UserMenu;
UserMenu.propTypes = {
  user: _pageStatePropTypes.UserPropTypes,
  condensed: _propTypes.default.bool,
  onLogout: _propTypes.default.func,
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string)
};
UserMenu.defaultProps = {
  condensed: false
};
var _default = exports.default = UserMenu;